/**
 * @generated SignedSource<<6de0cf659b86d81fcea2569cb47d7a56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamsAdminQuery$variables = Record<PropertyKey, never>;
export type TeamsAdminQuery$data = {
  readonly currentStore: {
    readonly allTeams: ReadonlyArray<{
      readonly id: string;
      readonly isArchived: boolean;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
    }>;
  };
};
export type TeamsAdminQuery = {
  response: TeamsAdminQuery$data;
  variables: TeamsAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "includeArchived",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamsAdminQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v0/*: any*/),
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "allTeams",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamIconCircleComponent_Team"
                }
              ],
              "storageKey": "allTeams(includeArchived:true)"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TeamsAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "allTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": "allTeams(includeArchived:true)"
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a098c96cbffa02c23168c8248229f650",
    "id": null,
    "metadata": {},
    "name": "TeamsAdminQuery",
    "operationKind": "query",
    "text": "query TeamsAdminQuery {\n  currentStore {\n    allTeams(includeArchived: true) {\n      id\n      isArchived\n      name\n      isPrivate\n      ...TeamIconCircleComponent_Team\n    }\n    id\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "56bcbfa4b03af7e40c332819770de335";

export default node;
